import React from "react";
import Select, { components } from "react-select";
import dropdown from "assets/img/dropdownSelect.svg";

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <img
        alt="dropdownicon"
        src={dropdown}
        height="10px"
      />
    </components.DropdownIndicator>
  );
};

const styles = {
  control: (base) => ({
    ...base,
    backgroundColor: "#FFF7E9",
    border: "none",
    boxShadow: "4px 9px 17px -1px #00000014",
    borderRadius: "25px",
    padding: "8px",
    minHeight: "90px",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    display: "none",
  }),
  indicatorsContainer: (base) => ({
    ...base,
    paddingRight: "10px",
  }),
  menu: (base) => ({
    ...base,
    zIndex: "2",
  }),
  option: (base) => ({
    ...base,
    backgroundColor: "none",
    color: "inherit",
  }),
};

const DropdownSelect = (props) => {
  return (
    <Select
      classNamePrefix="select"
      placeholder=""
      getOptionLabel={(option) => {
        return option?.displayLabel;
      }}
      components={{ DropdownIndicator }}
      styles={styles}
      {...props}
    />
  );
};

export default DropdownSelect;
